"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm$personalData;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column is-align-content-flex-end"
  }, [_c("div", {
    staticClass: "header-items"
  }, [_c("h5", {
    staticClass: "grid-h title-page"
  }, [_c("button", {
    attrs: {
      nbButton: ""
    },
    on: {
      click: _vm.goBack
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "arrow-left"
    }
  })], 1), _vm._v(" "), _c("h3", {
    staticClass: "title"
  }, [_vm._v("\n            Prova de Vida " + _vm._s(_vm.personalInfo.name ? " - ".concat(_vm.personalInfo.name) : "") + "\n          ")])])])])]), _vm._v(" "), _c("el-card", {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("div", {
    staticClass: "personal-infos"
  }, [_c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [_c("div", {
    staticClass: "header-personal-infos"
  }, [_c("div", {
    staticClass: "cpf-visibility-field"
  }, [_c("span", [_vm._v("CPF: "), _c("strong", [_vm._v(_vm._s(_vm.cpf))])]), _vm._v(" "), _vm.cpf ? _c("b-button", {
    staticClass: "cpf-visibility-field__button",
    attrs: {
      "aria-label": _vm.isCpfRevealed ? "Ocultar CPF" : "Visualizar CPF completo",
      "icon-left": _vm.isCpfRevealed ? "eye-off" : "eye",
      loading: _vm.isCpfLoading,
      title: _vm.isCpfRevealed ? "Ocultar CPF" : "Visualizar CPF completo",
      size: "is-small",
      type: "is-text"
    },
    on: {
      click: _vm.toggleCpfVisibility
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.personalInfo.name ? _c("div", [_vm._v("Nome: "), _c("strong", [_vm._v(_vm._s(_vm.personalInfo.name))])]) : _vm._e(), _vm._v(" "), _vm.birthdateLabel ? _c("div", [_vm._v("Data de nascimento: "), _c("strong", [_vm._v(_vm._s(_vm.birthdateLabel))])]) : _vm._e(), _vm._v(" "), _c("div", [_vm._v("Status: "), _c("strong", [_vm._v(_vm._s(_vm.processStatusLabel))])])])]), _vm._v(" "), _c("div", {
    staticClass: "column"
  }, [_c("div", {
    staticClass: "header-personal-infos"
  }, [_vm.personalInfo.city ? _c("div", [_vm._v("Cidade: "), _c("strong", [_vm._v(_vm._s(_vm.personalInfo.city))])]) : _vm._e(), _vm._v(" "), _vm.personalInfo.state ? _c("div", [_vm._v("Estado: "), _c("strong", [_vm._v(_vm._s(_vm.personalInfo.state))])]) : _vm._e(), _vm._v(" "), _vm.personalInfo.address ? _c("div", [_vm._v("Endereço: "), _c("strong", [_vm._v(_vm._s(_vm.personalInfo.address))])]) : _vm._e(), _vm._v(" "), _vm.personalInfo.zipCode ? _c("div", [_vm._v("CEP: "), _c("strong", [_vm._v(_vm._s(_vm.personalInfo.zipCode))])]) : _vm._e()])]), _vm._v(" "), _c("div", {
    staticClass: "column"
  }, [_c("div", {
    staticClass: "header-personal-infos"
  }, [_vm.personalInfo.phone ? _c("div", [_vm._v("Telefone: "), _c("strong", [_vm._v(_vm._s(_vm._f("maskPhone")(_vm.personalInfo.phone)))])]) : _vm._e(), _vm._v(" "), _vm.personalInfo.email ? _c("div", [_vm._v("E-mail: "), _c("strong", [_vm._v(_vm._s(_vm.personalInfo.email))])]) : _vm._e()])])]), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [_c("div", {
    staticClass: "header-personal-infos"
  }, [_vm.processStatusKey === "downloaded" ? _c("div", [_vm._v("Data do download: "), _c("strong", [_vm._v(_vm._s(_vm._f("date")((_vm$personalData = _vm.personalData) === null || _vm$personalData === void 0 ? void 0 : _vm$personalData.dateDownload)))])]) : _vm._e()])])]), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, [_vm.scoreRisco.value ? _c("div", {
    staticClass: "column"
  }, [_c("div", {
    staticClass: "diamond-container"
  }, [_c("canvas", {
    attrs: {
      id: "diamond-canvas",
      width: "343",
      height: "330"
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "vue-ellipse-risco-container"
  }, [_c("vue-ellipse-progress", {
    attrs: {
      half: "",
      angle: "0",
      size: 230,
      thickness: "5%",
      "line-mode": "in",
      progress: _vm.scoreRisco.valueAsInt,
      color: _vm.scoreRisco.gradientLineColors,
      "legend-formatter": function legendFormatter(_ref) {
        var currentValue = _ref.currentValue;
        return "<div class='ellipse-progress-info-risco'><span>".concat(currentValue, "%</span><span>Score de Valida\xE7\xE3o</span></div>");
      }
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "tag-legenda-risco"
  }, [_c("el-tag", {
    attrs: {
      id: "tag-score-risco",
      color: _vm.scoreRisco.legendTagBgColor,
      effect: "dark"
    }
  }, [_vm._v(_vm._s(_vm.scoreRisco.legendTagText))])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c("div", {
    style: !_vm.scoreRisco.value ? {
      margin: "0 auto",
      width: "calc(100% - 410px)"
    } : {
      width: "calc(100% - 410px)"
    }
  }, [_c("b-tabs", {
    model: {
      value: _vm.abaAtiva,
      callback: function callback($$v) {
        _vm.abaAtiva = $$v;
      },
      expression: "abaAtiva"
    }
  }, _vm._l(_vm.baseTabs, function (aba) {
    var _vm$personalData2, _vm$personalData3;
    return _c("b-tab-item", {
      key: aba,
      attrs: {
        label: aba
      }
    }, [aba === "Dossiê" ? _c("CardLivenessDossie", {
      attrs: {
        "item-id": _vm.itemId,
        validation: _vm.personalData
      }
    }) : aba === "Face" ? _c("CardValidaFace", {
      attrs: {
        "item-id": _vm.itemId,
        data: _vm.personalData
      }
    }) : aba === "Documentos" ? _c("CardValidaDocuments", {
      attrs: {
        "item-id": _vm.itemId,
        data: (_vm$personalData2 = _vm.personalData) === null || _vm$personalData2 === void 0 ? void 0 : _vm$personalData2.documents
      }
    }) : aba === "Histórico" ? _c("CardLivenessHistory", {
      attrs: {
        history: (_vm$personalData3 = _vm.personalData) === null || _vm$personalData3 === void 0 ? void 0 : _vm$personalData3.histories
      }
    }) : _vm.isInsightTab(aba) ? _c("div", {
      staticClass: "detail-insight-tab"
    }, [_c("div", {
      staticClass: "detail-insight-tab__summary"
    }, [_c("div", {
      staticClass: "detail-insight-tab__eyebrow"
    }, [_vm._v("\n                    Análise Complementar\n                  ")]), _vm._v(" "), _c("div", {
      staticClass: "detail-insight-tab__headline"
    }, [_c("div", [_c("h2", [_vm._v(_vm._s(_vm.getInsightSummary(aba).title))]), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.getInsightSummary(aba).description))])]), _vm._v(" "), _c("span", {
      class: ["tag", "detail-insight-tab__status-chip", _vm.getInsightSummary(aba).tagClass]
    }, [_c("b-icon", {
      attrs: {
        icon: _vm.getInsightSummary(aba).icon,
        size: "is-small"
      }
    }), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.getInsightSummary(aba).tagLabel))])], 1)])]), _vm._v(" "), _c("section", {
      staticClass: "detail-insight-tab__section"
    }, [_c("div", {
      staticClass: "detail-insight-tab__section-header"
    }, [_c("div", {
      staticClass: "detail-insight-tab__section-title"
    }, [_c("b-icon", {
      attrs: {
        icon: "table"
      }
    }), _vm._v(" "), _c("h3", [_vm._v(_vm._s(_vm.getInsightSummary(aba).sectionTitle))])], 1), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.getInsightSummary(aba).sectionDescription))])]), _vm._v(" "), _c("el-table", {
      staticClass: "detail-insight-tab__table",
      attrs: {
        border: "",
        stripe: "",
        data: _vm.insights[aba.toLowerCase()],
        "default-sort": {
          prop: "relevance"
        }
      }
    }, [_c("el-table-column", {
      attrs: {
        prop: "relevance",
        label: "Relevância",
        width: "122",
        sortable: "",
        filters: [{
          text: "Positivo",
          value: "Positivo"
        }, {
          text: "Neutro",
          value: "Neutro"
        }, {
          text: "Alerta",
          value: "Alerta"
        }],
        "filter-method": _vm.relevanceFilterHandler
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(scope) {
          return [_c("div", {
            staticStyle: {
              "text-align": "center"
            }
          }, [_c("el-tag", {
            attrs: {
              size: "mini",
              type: scope.row.relevance === "Alerta" ? "danger" : scope.row.relevance === "Neutro" ? "info" : ""
            }
          }, [_vm._v(_vm._s(scope.row.relevance))])], 1)];
        }
      }], null, true)
    }), _vm._v(" "), _c("el-table-column", {
      attrs: {
        prop: "code",
        label: "Código",
        width: "91",
        sortable: ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(scope) {
          return [_c("div", {
            staticStyle: {
              "text-align": "center",
              "font-family": "monospace, monospace"
            }
          }, [_vm._v("\n                          " + _vm._s(scope.row.code) + "\n                        ")])];
        }
      }], null, true)
    }), _vm._v(" "), _c("el-table-column", {
      attrs: {
        prop: "insights",
        label: "Descrição",
        sortable: ""
      }
    }), _vm._v(" "), _c("el-table-column", {
      attrs: {
        prop: "category",
        label: "Categoria",
        width: "180",
        sortable: ""
      }
    })], 1)], 1)]) : _vm._e()], 1);
  }), 1)], 1)])])])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;